// extracted by mini-css-extract-plugin
export default {"copyBtn":"CopyToClipboardButton_copyBtn__fuE9N"};